import * as React from 'react';
import { rgba } from 'polished';
import styled from 'styled-components';

const DEFAULT_POS = '-9px';
const SIZE = '15px';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 !important;
  pointer-events: none;
  opacity: 1;
  transition: opacity ${({ theme }) => theme.animation.DURATION}
    ${({ theme }) => theme.animation.EASING};

  > span:before,
  > span:after {
    content: '';
    display: block;
    position: absolute;
    width: ${SIZE};
    height: ${SIZE};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => rgba(theme.highlightColor, 0.3)};

    [data-theme='pink'] & {
      border: 1px solid ${({ theme }) => theme.paletteCssVars.grid700};
    }
  }
`;

const Left = styled.span`
  &:before {
    top: ${DEFAULT_POS};
    left: ${DEFAULT_POS};
  }

  &:after {
    bottom: ${DEFAULT_POS};
    left: ${DEFAULT_POS};
  }
`;

const Right = styled.span`
  &:before {
    top: ${DEFAULT_POS};
    right: ${DEFAULT_POS};
  }

  &:after {
    bottom: ${DEFAULT_POS};
    right: ${DEFAULT_POS};
  }
`;

interface CornerCirclesProps {
  className?: string;
}

export const CornerCircles: React.ComponentType<CornerCirclesProps> =
  React.memo(({ className }) => {
    return (
      <Wrapper className={className} data-which="corner-circles">
        <Left />
        <Right />
      </Wrapper>
    );
  });
